
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {fetchDashboardDataNew} from 'redux/modules/dashboard/actions'
import {
  setTimePeriod,
  setConversionType,
  selectGlobalDateRange
} from 'redux/modules/currentUser/actions'
import {getMetrics} from 'redux/modules/insights/selectors'
import {
  getCurrentMonthDataFetching,
  getCurrentPeriodData,
  getCurrentPeriodTraffic,
  getLastOrders
} from 'redux/modules/dashboard/selectors'
import {
  getCurrentTimePeriod,
  getTimePeriodRanges,
  getSelectedDateRange,
  getAggregatedSites,
  getConverionType
} from 'redux/modules/currentUser/selectors'
import isRangeEqual from 'utils/isRangeEqual'
import formatTimePeriodDate from 'utils/formatTimePeriodDate'
import Container from 'components/ContainerDimentionsContext'
import Label from 'components/Label'
import TimePeriodDashboard from 'components/TimePeriodDashboard'
import Legend from 'components/Legend'
import Select from 'components/Select'
import propsChanged from 'utils/propsChanged'
import isEqual from 'lodash/isEqual'
import DashboardChart from 'components/DashboardChart'
import {Table, Column, Cell} from 'components/Table'

import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'
import NumberFormat from 'components/NumberFormat'

const modes = {
  daily: 'Daily',
  aggregated: 'Summarized'
}

export class DashboardView extends React.Component {
  static propTypes = {
    fetchDashboardDataNew: PropTypes.func.isRequired,
    setTimePeriod: PropTypes.func.isRequired,
    setConversionType: PropTypes.func.isRequired,
    currentPeriodData: PropTypes.array,
    conversionType: PropTypes.string,
    timePeriod: PropTypes.string,
    crossSiteMode: PropTypes.bool,
    today: PropTypes.instanceOf(Date),
    total: PropTypes.shape({
      traffic: PropTypes.object,
      orderCount: PropTypes.object,
      costValue: PropTypes.object,
      orderValue: PropTypes.object
    }),
    timePeriodRanges: PropTypes.object,
    sites: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    currentPeriodDataFetching: PropTypes.bool,
    dashboardTable: PropTypes.array,
    metrics: PropTypes.object
  }

  conversions = [
    {
      name: 'Registration Finished',
      value: 'Reg finished'
    },
    {
      name: 'First Time Deposit',
      value: 'FTD'
    }
  ]

  static contextTypes = {
    permissions: PropTypes.object,
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedMode: 'daily',
      selectedMetric: 'order:count-non-direct-touch'
    }
  }

  componentDidMount() {
    const {fetchDashboardDataNew, crossSiteMode} = this.props
    const {currency, timezone} = this.context
    setTimeout(() => {
      fetchDashboardDataNew(crossSiteMode, currency, timezone)
    }, 200)
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {currency, timezone} = nextContext
    const {
      fetchDashboardDataNew,
      sites,
      timePeriod,
      timePeriodRanges,
      conversionType
    } = this.props
    const {
      timePeriodRanges: nextTimePeriodRanges,
      currentPeriodDataFetching,
      crossSiteMode
    } = nextProps
    const sitesChanged = !isEqual(sites, nextProps.sites)
    const conversionTypeChanged = !isEqual(
      conversionType,
      nextProps.conversionType
    )
    const timePeriodChanged = timePeriod !== nextProps.timePeriod
    const timeRangesValid =
      nextTimePeriodRanges &&
      !!nextTimePeriodRanges.start &&
      !!nextTimePeriodRanges.end
    if (!timeRangesValid) return null

    const timeRangesChanged =
      propsChanged(this.props, nextProps, ['timePeriodRanges']) ||
      !(
        isRangeEqual(timePeriodRanges.start, nextTimePeriodRanges.start) &&
        isRangeEqual(timePeriodRanges.end, nextTimePeriodRanges.end)
      )
    if (
      !currentPeriodDataFetching &&
      (sitesChanged ||
        timePeriodChanged ||
        timeRangesChanged ||
        conversionTypeChanged)
    ) {
      fetchDashboardDataNew(crossSiteMode, currency, timezone)
    }
  }

  render() {
    return (
      <div className='dashboard'>
        {this.renderSelector()}
        {this.renderAnalyticChart()}
        {this.renderTouchedTable()}
      </div>
    )
  }

  renderSelector() {
    const {
      today,
      timePeriod,
      currentPeriodDataFetching,
      dynamicDateType,
      timePeriodRanges
    } = this.props

    const currentPeriodName = timePeriodRanges
      ? formatTimePeriodDate(timePeriod, timePeriodRanges.start.start)
      : null
    const anotherPeriodName = timePeriodRanges
      ? formatTimePeriodDate(timePeriod, timePeriodRanges.end.start)
      : null
    return (
      <div className='dashboard_selector container'>
        <div className='dashboard_header'>
          {this.renderMetricSelect()}
          <TimePeriodDashboard
            className='dashboard_header_period'
            disabled={currentPeriodDataFetching}
            timePeriod={timePeriod}
            dynamicDateType={dynamicDateType}
            timeRanges={timePeriodRanges}
            today={today}
            onSelect={this.onSelectPeriod}
            short
          />
          <Legend className='dashboard_header_legend' align='right'>
            <Label color='awesome-blue' line>
              {currentPeriodName}
            </Label>
            <Label color='lightest' line>
              {anotherPeriodName}
            </Label>
            <Label color='awesome-blue' line dashed>
              Projection
            </Label>
          </Legend>
        </div>
      </div>
    )
  }

  renderAnalyticChart() {
    const {total} = this.props
    const CPACurrent =
      total.costValue.currentMonth !== 0
        ? total.costValue.currentMonth / total.orderCount.currentMonth
        : 0
    const CPAPrevious =
      total.costValue.prevMonth !== 0
        ? total.costValue.prevMonth / total.orderCount.prevMonth
        : 0
    const CPAUp =
      CPACurrent !== 0 ? (CPACurrent - CPAPrevious) / CPAPrevious : 0
    const ConvertionCurrent = total.orderCount.currentMonth
    const ConvertionPrevious = total.orderCount.prevMonth
    const ConvertionUp =
      ConvertionCurrent !== 0
        ? (ConvertionCurrent - ConvertionPrevious) / ConvertionPrevious
        : 0

    const FtdCurrent = total.ftdCount.currentMonth
    const FtdPrevious = total.ftdCount.prevMonth
    const FtdUp =
      FtdCurrent !== 0 ? (FtdCurrent - FtdPrevious) / FtdPrevious : 0

    const RegCurrent = total.regCount.currentMonth
    const RegPrevious = total.regCount.prevMonth
    const RegUp =
      RegCurrent !== 0 ? (RegCurrent - RegPrevious) / RegPrevious : 0

    const CostCurrent = total.costValue.currentMonth
    const CostPrevious = total.costValue.prevMonth
    const CostUp =
      CostCurrent !== 0 ? (CostCurrent - CostPrevious) / CostPrevious : 0
    return (
      <div className='dashboard_analytic'>
        {this.renderItem(
          'Total Conversions',
          ConvertionCurrent,
          'number',
          ConvertionUp,
          'percent',
          'Conversions',
          'orderCount'
        )}
        {this.renderItem(
          'FTD Conversions',
          FtdCurrent,
          'number',
          FtdUp,
          'percent',
          'Conversions',
          'ftdCount'
        )}
        {this.renderItem(
          'Reg Finish Conversions',
          RegCurrent,
          'number',
          RegUp,
          'percent',
          'Conversions',
          'regCount'
        )}
        {this.renderItem(
          'Total Costs',
          CostCurrent,
          'number',
          CostUp,
          'percent',
          'Cost',
          'costValue'
        )}
        {this.renderItem(
          'CPA Conversions (FTD)',
          CPACurrent,
          'decimalDouble',
          CPAUp,
          'percent',
          'CPA',
          'CPAValue'
        )}
        {this.renderItem(
          'CPA Conversions (Reg Fin)',
          CPACurrent,
          'decimalDouble',
          CPAUp,
          'percent',
          'CPA',
          'CPAValue'
        )}
      </div>
    )
  }

  renderItem(
    title,
    numberBigValue,
    numberBigValueFormat,
    valueUp,
    valueUpFormat,
    chartTitle,
    chartColumn
  ) {
    const {
      today,
      total,
      currentPeriodData,
      currentPeriodDataFetching,
      timePeriod,
      timePeriodRanges
    } = this.props
    const {selectedMode} = this.state
    const aggregated = selectedMode === 'aggregated'

    const currentPeriodName = timePeriodRanges
      ? formatTimePeriodDate(timePeriod, timePeriodRanges.start.start)
      : null
    const anotherPeriodName = timePeriodRanges
      ? formatTimePeriodDate(timePeriod, timePeriodRanges.end.start)
      : null

    return (
      <div className='dashboard_analytic-item'>
        <div className='dashboard_analytic-title is-loading'>{title}</div>
        <div className='dashboard_analytic-number'>
          <NumberFormat
            value={!currentPeriodDataFetching ? numberBigValue : 0}
            format={numberBigValueFormat}
          />
        </div>
        <div className='dashboard_analytic-compare'>
          <span className={valueUp > 0 ? 'up' : valueUp < 0 ? 'down' : ''}>
            {valueUp > 0 ? '+' : ''}
            <NumberFormat
              value={!currentPeriodDataFetching ? valueUp : 0}
              format={valueUpFormat}
            />
          </span>
          <span>from previous period</span>
        </div>
        <div className='dashboard_analytic-chart'>
          <Container className='chart-base'>
            <DashboardChart
              data={currentPeriodData}
              field={chartColumn}
              today={today}
              title={chartTitle}
              total={total}
              format={numberBigValueFormat}
              aggregated={aggregated}
              loading={currentPeriodDataFetching}
              currentPeriodName={currentPeriodName}
              anotherPeriodName={anotherPeriodName}
            />
          </Container>
        </div>
      </div>
    )
  }
  renderMetricSelect() {
    const {selectedMode} = this.state

    return (
      <div className='overview-table_metrics dashboard_header_mode'>
        <div className='overview-table_metrics_title'>Display</div>
        <Select
          className='overview-table_select'
          value={selectedMode}
          options={Object.keys(modes).map(mode => ({
            name: modes[mode],
            value: mode
          }))}
          onSelect={this.onModeChange}
        />
      </div>
    )
  }

  onMetricChange = item => {
    this.setState({selectedMetric: item.value})
  }

  renderTouchedTable() {
    const {
      dashboardTable,
      dashboardTableTotal,
      conversionType,
      currentPeriodDataFetching,
      metrics
    } = this.props
    const {selectedMetric} = this.state
    const data = dashboardTable
    const total = dashboardTableTotal
    return (
      <div className='dashboard_channels'>
        <div className='order-touched_header'>
          <div className='order-touched_header_title'>Conversions</div>
          <div className='order-touched_selects'>
            <Select
              className='order-touched_select'
              value={conversionType}
              options={this.conversions}
              onSelect={this.onSelectConversion}
            />
            <Select
              className='order-touched_select'
              value={selectedMetric}
              options={Object.keys(metrics).map(metric => ({
                name: metrics[metric].model,
                value: metric
              }))}
              onSelect={this.onMetricChange}
            />
          </div>
        </div>
        <Table
          data={data}
          empty='No statistics for chosen date period.'
          loading={currentPeriodDataFetching}
          loadingRows={2}
          hover
        >
          <Column
            width='20%'
            header={<Cell align='left'>Channel</Cell>}
            cell={statRow => this.renderChannelTableRow(statRow.dimensions)}
          />
          <Column
            width='20%'
            header={<Cell align='right'>Conversions Touched</Cell>}
            cell={col => (
              <Cell align='right' format='number'>
                {col['order:count-every-session'] || '0'}
              </Cell>
            )}
          />
          <Column
            width='20%'
            header={<Cell align='right'>Touchpoints before conversion</Cell>}
            cell={col => (
              <Cell align='right' format='number'>
                {col['order:count-touchpoint'] || '0'}
              </Cell>
            )}
          />
          <Column
            width='20%'
            header={<Cell align='right'>Total Attributed Conversions</Cell>}
            cell={col => (
              <Cell align='right' format='decimalDouble'>
                {col[selectedMetric] || '0'}
              </Cell>
            )}
          />
          <Column
            width='20%'
            header={
              <Cell align='right'>% of Attributed Conversions Touched</Cell>
            }
            cell={col =>
              this.renderPercentTableRow(
                col[selectedMetric],
                total['order:count'],
                'percent'
              )
            }
          />
        </Table>
      </div>
    )
  }

  renderPercentTableRow(value, total, format) {
    return (
      <Cell align='right' format={format}>
        {value !== 0 && total !== 0 ? value / total : '0'}
      </Cell>
    )
  }
  renderChannelTableRow(dimension) {
    return (
      <Cell>
        <div className='traffic-insight-view-channel'>
          <div className='traffic-insight-view-channel_group-title non_mb'>
            <ChannelGroupTitle id={dimension.channelGroup} noIcon />
          </div>
          <div className='traffic-insight-view-channel_title'>
            <ChannelTitle id={dimension.channel} iconSize='16px' />
          </div>
        </div>
      </Cell>
    )
  }

  onSelectPeriod = (timePeriod, startRange, endRange, dynamicDateType) => {
    const {setTimePeriod} = this.props
    if (!timePeriod) return null
    setTimePeriod({
      timePeriod,
      startRange,
      endRange,
      dynamicDateType
    })
  }

  onSelectConversion = item => {
    this.props.setConversionType(item.value)
  }

  onModeChange = mode => {
    this.setState({
      selectedMode: mode.value
    })
  }
}

const mapStateToProps = (state, props) => {
  const {metric} = props.route
  const {dynamicDateType} = getSelectedDateRange(state)
  const timePeriod = getCurrentTimePeriod(state)
  const timePeriodRanges = getTimePeriodRanges(state)
  const conversionType = getConverionType(state)
  const crossSiteMode = props.route.crossSiteMode
  const metrics = getMetrics(metric)
  return {
    today: state.today,
    dashboardTable: state.dashboard.table,
    dashboardTableTotal: state.dashboard.tableTotal,
    timePeriod,
    dynamicDateType,
    timePeriodRanges,
    conversionType,
    crossSiteMode,
    sites: getAggregatedSites(state, crossSiteMode),
    currentPeriodData: getCurrentPeriodData(state, timePeriodRanges),
    currentPeriodTraffic: getCurrentPeriodTraffic(state, timePeriodRanges),
    currentPeriodDataFetching: getCurrentMonthDataFetching(state),
    maxSessionCount: state.dashboard.maxSessionCount,
    lastOrders: getLastOrders(state),
    total: state.dashboard.total,
    metrics
  }
}

export default connect(mapStateToProps, {
  fetchDashboardDataNew,
  selectGlobalDateRange,
  setTimePeriod,
  setConversionType
})(DashboardView)



// WEBPACK FOOTER //
// ./client/views/DashboardView/index.js